/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per person`)
};

const es_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por persona`)
};

const de_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Person`)
};

const nl_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per persoon`)
};

const fr_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par personne`)
};

const it_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A persona`)
};

const pt_br2_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por pessoa`)
};

const pt_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por pessoa`)
};

const ja_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一人当たり`)
};

const zh_pct_result_per_person = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每人`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_result_per_person = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_result_per_person(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_result_per_person", locale)
	if (locale === "en") return en_pct_result_per_person(inputs)
	if (locale === "es") return es_pct_result_per_person(inputs)
	if (locale === "de") return de_pct_result_per_person(inputs)
	if (locale === "nl") return nl_pct_result_per_person(inputs)
	if (locale === "fr") return fr_pct_result_per_person(inputs)
	if (locale === "it") return it_pct_result_per_person(inputs)
	if (locale === "pt-BR") return pt_br2_pct_result_per_person(inputs)
	if (locale === "pt") return pt_pct_result_per_person(inputs)
	if (locale === "ja") return ja_pct_result_per_person(inputs)
	return zh_pct_result_per_person(inputs)
};